import axios from './axios'
import { ScoringCalculator } from '@/../../EshJSLib/models/scoringCalculator'
import * as model from '@/../../EshJSLib/models/patient';


//getHasBledScore() function returns items which are used to calculate has-bled-score
export async function getFilteredListScore(score_type:string) {
    const response = await axios.get(`/api/scoring/${score_type}`);
    return response.data.data as model.ScoringCalculator[];
}

//getHasBledScoreResultList returns combination of points and results of only has-bled
export async function getFilteredCombinationList(score_type:string){
    const response = await axios.get(`/api/score-result/${score_type}`);
    return response.data.data  as model.ScoreResult[];
}

